var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props),
    React.createElement(
      "title",
      null,
      "AccountsConfirmed"
    ),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M20.05 10a10 10 0 1 1-10-10 10.09 10.09 0 0 1 10 10zm-11.2 5.3l7.4-7.4a.56.56 0 0 0 0-.9l-.9-.9a.56.56 0 0 0-.9 0l-6 6-2.8-2.8a.56.56 0 0 0-.9 0l-.9.9a.56.56 0 0 0 0 .9l4.2 4.2a.47.47 0 0 0 .8 0z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Confirmed.svg